import React, { Component } from 'react';
import { Label } from 'semantic-ui-react'
import { TransitionContainer } from '../utility/GlobalComponents';


export default class Data extends Component {

    render () {
        return (
            <TransitionContainer className='mv-data-container'>
                <Label size='massive'>Coming Soon</Label>
            </TransitionContainer>
        )
    }
}